module.exports = __webpack_public_path__ + "static/fonts/iconfont.b63632d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/fonts/iconfont.woff?v=1.0.0
// module id = 4beH
// module chunks = 35